import { render, staticRenderFns } from "./RouteDetails.vue?vue&type=template&id=72239350&scoped=true"
import script from "./RouteDetails.vue?vue&type=script&lang=js"
export * from "./RouteDetails.vue?vue&type=script&lang=js"
import style0 from "./RouteDetails.vue?vue&type=style&index=0&id=72239350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72239350",
  null
  
)

export default component.exports